import { render, staticRenderFns } from "./defaultScvColumns.vue?vue&type=template&id=69573e50&scoped=true&"
import script from "./defaultScvColumns.vue?vue&type=script&lang=js&"
export * from "./defaultScvColumns.vue?vue&type=script&lang=js&"
import style0 from "./defaultScvColumns.vue?vue&type=style&index=0&id=69573e50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69573e50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VRow,VSkeletonLoader})
